import React from "react";

import "./App.css";
// import AppFooter from './Components/AppFooter';
// import AppHeader from './Components/AppHeader';
import { AppRouter } from "./Routes/AppRouter";
import { AuthProvider } from "./Context/authContext";
import { QueryClient, QueryClientProvider } from "react-query";
import { Provider } from "react-redux";
import store from "./store/store";
//QueryClient Config
const queryCLient = new QueryClient({
  defaultOptions: {
    queries: false,
    refetchOnMount: true,
    enabled: false,
  },
});

function App() {
  return (
    <>
      <QueryClientProvider client={queryCLient}>
        <AuthProvider>
          <Provider store={store}>
            <AppRouter></AppRouter>
          </Provider>
        </AuthProvider>
      </QueryClientProvider>
    </>
  );
}

export default App;
